import { Model } from 'pinia-orm';
import { Profile } from './Profile';
import { Child } from '../../Child/models/Child';
import { Avatar } from '../../Avatar/models/Avatar';
import { UserStep } from 'modules/Step/models/UserStep';
import {
  Str,
  Bool,
  Uid,
  HasOne,
  HasMany,
  Attr,
} from 'pinia-orm/decorators';
import { Role } from './Role';
import type { PluginUsersPermissionsUser } from 'src/types/contentTypes';
import type { StrapiAttr } from 'src/types/strapi';

/** Scalar field types are derived from the backend schema — see src/types/strapi.ts. */
type UserAttr<K extends keyof PluginUsersPermissionsUser['attributes']> =
  StrapiAttr<PluginUsersPermissionsUser, K>;

export class User extends Model {
  static override entity = 'users';
  @Uid() declare id: number;
  @Str('') declare documentId: string;
  @Str('') declare email: UserAttr<'email'>;
  @Str('') declare firstname: UserAttr<'firstname'>;
  @Str('') declare lastname: UserAttr<'lastname'>;
  @Bool(false) declare blocked: UserAttr<'blocked'>;
  @Attr(null) declare school: { id: number; documentId: string } | null;

  @HasOne(() => Profile, 'user_id') declare profile: Profile | null;
  @HasMany(() => Child, 'user_id') declare children: Child[];
  @HasOne(() => Child, 'user_id') declare child: Child | null;
  @HasOne(() => Role, 'user_id') declare role: Role | null;
  @HasOne(() => Avatar, 'user_id') declare avatar: Avatar | null;
  @HasMany(() => UserStep, 'user_id') declare user_steps: UserStep[];
}
